export default __webpack_public_path__ + "static/media/alta-bms.002672af.png";